import useConditionalEffect from 'hooks/useConditionalEffect'
import { ReactNode, useCallback } from 'react'
import { connect } from 'react-redux'
import { getLists } from 'services/lists/actions'
import { StoreThunkDispatch } from 'store/state'
import { List } from 'shared'

export interface FetchListsProps {
  force?: boolean
  onFetched?(destinations: List[]): void
  onFailed?(err: any): void
  children?: ReactNode
}

interface ConnectedFetchListsProps extends FetchListsProps {
  getLists(): Promise<List[]>
}

const FetchLists = ({
  force,
  children,
  onFetched,
  onFailed,
  getLists: getListsAction
}: ConnectedFetchListsProps) => {
  const handleFetched = useCallback((destinations: List[]) => {
    if (onFetched) {
      onFetched(destinations)
    }
  }, [onFetched])

  const handleFailed = useCallback((err: any) => {
    if (onFailed) {
      onFailed(err)
    }
  }, [onFailed])

  const fetch = useCallback(() => {
    getListsAction().then(handleFetched).catch(handleFailed)
  }, [getListsAction, handleFetched, handleFailed])

  useConditionalEffect(([_fetch]) => {
    _fetch()
  }, [force], [fetch])

  return children || null
}

function mapDispatchToProps(dispatch: StoreThunkDispatch, ownProps: FetchListsProps) {
  const force = ownProps.force !== undefined ? ownProps.force : true // true by default
  return {
    getLists: () => dispatch(getLists(force))
  }
}

export default connect(null, mapDispatchToProps)(FetchLists as any)
